<template>
  <list mode="report" :items="reports" @load="onLoad" @delete="onDelete" />
</template>

<script>
import List from "@/components/list"
import Reports from "@/api/reports"
export default {
  name: "Reports",
  components: { List },
  data() {
    return {
      reports: {
        limit: 20,
        offset: 0,
        count: 0,
        results: []
      }
    }
  },
  methods: {
    onLoad() {
      if (this.reports.count == 0 || this.reports.offset < this.reports.count) {
        this.setBusy(true)
        Reports.list(this.reports.offset).then(response => {
          this.reports.count = response.data.count
          this.reports.results.push(...response.data.results)
          this.reports.offset += this.reports.limit
        }).finally(() => this.setBusy(false))
      }
    },
    onDelete(items) {
      Reports.delete({ items: items }).then(response => {
        this.notify(response.data)
        this.refresh()
      })
    }
  }
}
</script>
